export const BUTTON_SIZE = 48;
export const EDGE_MARGIN = 5;
export const DEFAULT_POSITION_X = 24;
export const DRAG_THRESHOLD = 5;

/** 本地和测试环境用 RMSUAT，线上用 RMS */
export const MI_SUPPORT_CHANNEL =
  process.env.VUE_APP_ENV === 'test' || process.env.VUE_APP_ENV === 'development'
    ? 'RMSUAT'
    : 'RMS';
export const MI_SUPPORT_SYSTEM = 'RMS';

export const MI_IT_ORIGIN =
  process.env.VUE_APP_ENV === 'test' || process.env.VUE_APP_ENV === 'development'
    ? 'wf-e.test.mioffice.cn'
    : 'wf.e.mioffice.cn';

export const LANGUAGE_MAP = {
  'en-US': 'en',
  'es-ES': 'esp',
  'th-TH': 'tai',
  'ar-SA': 'arab',
  'ms-MY': 'mala',
  'id-ID': 'ind',
  'vi-VN': 'vie',
  'zh-CN': 'zh'
};
